import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutAlignLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-align-left"} maskId="square-filled-radius-0-stroke-1-IconLayoutAlignLeft"><path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM8 7H7L7 17H8L8 7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutAlignLeft;
